module.exports = __webpack_public_path__ + "img/Page3A.cb54eea3.jpg";